"use client";

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShoppingBag, Store, Layers } from 'lucide-react';

export const Pricing = () => {
  const { t } = useTranslation();

  const scrollToContact = () => {
    const contact = document.getElementById('contact');
    if (contact) {
      contact.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const plans = [
    {
      icon: <Store className="w-12 h-12 text-blue-300" />,
      title: t('pricing.b2b.title'),
      desc: t('pricing.b2b.desc'),
      features: [
        t('services.ecommerceDesc'),
        t('services.seoDesc'),
        t('services.hostingDesc')
      ]
    },
    {
      icon: <ShoppingBag className="w-12 h-12 text-blue-300" />,
      title: t('pricing.retail.title'),
      desc: t('pricing.retail.desc'),
      features: [
        t('services.ecommerceDesc'),
        t('services.seoDesc'),
        t('services.hostingDesc')
      ]
    },
    {
      icon: <Layers className="w-12 h-12 text-blue-300" />,
      title: t('pricing.combo.title'),
      desc: t('pricing.combo.desc'),
      features: [
        t('services.ecommerceDesc'),
        t('services.seoDesc'),
        t('services.hostingDesc')
      ]
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-gradient-to-br from-blue-600/20 to-slate-900/20">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4 text-gradient text-glow">{t('pricing.title')}</h2>
        <p className="text-blue-200/80 text-center mb-12 max-w-2xl mx-auto">{t('pricing.subtitle')}</p>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {plans.map((plan, index) => (
            <div key={index} className="relative group h-full">
              <div className="absolute -inset-[1px] rounded-xl bg-gradient-to-r from-blue-500/50 to-blue-500/50 blur-sm opacity-75 group-hover:opacity-100 transition-opacity"></div>
              <div className="absolute -inset-[1px] rounded-xl bg-gradient-to-r from-blue-500 to-blue-500 opacity-75 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative bg-slate-950 h-full p-8 rounded-xl transition-all duration-300 hover:scale-105 flex flex-col">
                <div className="flex items-center justify-center mb-6">
                  {plan.icon}
                </div>
                <h3 className="text-2xl font-semibold mb-2 text-white text-center">{plan.title}</h3>
                <p className="text-blue-200/80 text-center mb-6">{plan.desc}</p>
                <ul className="text-blue-200/80 space-y-2 mt-auto mb-8">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-start">
                      <div className="w-1.5 h-1.5 rounded-full bg-blue-400 mr-2 mt-2 flex-shrink-0"></div>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="relative group">
                  <div className="absolute -inset-[1px] rounded-lg bg-gradient-to-r from-blue-500/50 to-blue-500/50 opacity-75 blur-sm group-hover:opacity-100 transition-opacity"></div>
                  <div className="absolute -inset-[1px] rounded-lg bg-gradient-to-r from-blue-500 to-blue-500 opacity-75 group-hover:opacity-100 transition-opacity"></div>
                  <button
                    onClick={scrollToContact}
                    className="relative block w-full px-6 py-3 bg-slate-950 rounded-lg text-blue-300 transition-all group-hover:scale-[1.02] font-semibold"
                  >
                    {t('pricing.contactUs')}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
